module.exports = __webpack_public_path__ + "static/media/everise.a6f46795.svg";